module.exports = __webpack_public_path__ + "static/icons/icon-chevron-circle-right--white-c4b4a0bdb23f5779c32f22528a61f582.svg";